import React, { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StudioWorkspaceProvider } from "../context/StudioWorkspaceProvider";
import { StudioRuntimeProvider } from "./StudioRuntimeProvider";

function createStudioQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });
}

/**
 * Minimal provider shell for modules that need workspace + runtime binding
 * and Studio data hooks (e.g. Firestore Manager).
 */
export default function StudioRuntimeShell({ children }) {
  const [queryClient] = useState(createStudioQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <StudioWorkspaceProvider>
        <StudioRuntimeProvider>
          {children}
        </StudioRuntimeProvider>
      </StudioWorkspaceProvider>
    </QueryClientProvider>
  );
}
